import styles from './Universe26BannerVisual.module.css'
import universe26VisualSupercharge from './assets/universe_26-visual-supercharge.webp'

export function Universe26BannerVisual() {
  return (
    <div className={styles.visualContainer}>
      <img src={universe26VisualSupercharge} className={styles.visualImage} alt="" />
    </div>
  )
}
